import { useState, useEffect } from "react";
import styled from "styled-components";
import theme from "../../theme/theme";
import { defaultRegex } from "../../Regex";
import { useCallback } from "react";
import { useSelector } from "react-redux";

const MainWrapper = styled.div`
  margin-bottom: 0%;
  text-align: left;
`;

const LabelWrapper = styled.label`
  font-size: 12px;
  color: red;
  display: ${(props) => (props.isLabelVisible ? "block" : "none")};
  width: 300px;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const InputWrapper = styled.input`
  border: ${(props) =>
    props.outlined
      ? `2px solid  ${props.isError ? "red" : theme.colors.primary}`
      : "none"};
  border-bottom: ${(props) =>
    `2px solid ${
      props.isError
        ? "red"
        : props?.disabled
        ? "lightgray"
        : theme.colors.primary
    }`};
  padding: 10px 20px;
  border-radius: ${(props) => (props.outlined ? "5px" : "0px")};
  width: -webkit-fill-available;
  background-color: transparent;
  color: gray;
`;

const CustomTextBox = ({
  placeholder,
  name = "",
  outlined = false,
  type = "text",
  regexCode = defaultRegex,
  disabled = false,
  errorMessage = "",
  value = "",
  isRepeteadMail = false,
  setIsRepeteadMail = () => {},
  onBlur = () => {},
  onKeyPress = () => {},
  onChange = () => {},
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isError, setIsError] = useState(false);
  const { userAccountDetails } = useSelector((state) => state.user);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    onChange(name, event.target.value);
  };

  const handleOnBlur = useCallback(() => {
    if (inputValue.toString().trim() !== "") {
      if (!regexCode.test(inputValue)) {
        onBlur(name, "");
        setIsRepeteadMail(false);
        setIsError(true);
      } else {
        if (inputValue === userAccountDetails?.email) {
          setIsRepeteadMail(true);
        } else {
          onBlur(name, inputValue);
          setIsError(false);
          setIsRepeteadMail(false);
        }
      }
    } else {
      onBlur(name, "");
      setIsError(false);
    }
  }, [
    inputValue,
    name,
    onBlur,
    regexCode,
    setIsRepeteadMail,
    userAccountDetails?.email,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleOnBlur();
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [inputValue, handleOnBlur]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <MainWrapper>
      <InputWrapper
        outlined={outlined}
        name={name}
        placeholder={placeholder}
        value={inputValue}
        type={type}
        disabled={disabled}
        onChange={handleInputChange}
        onBlur={handleOnBlur}
        onKeyPress={onKeyPress}
        isError={isRepeteadMail || isError}
      ></InputWrapper>
      <LabelWrapper isLabelVisible={isRepeteadMail || isError}>
        {errorMessage}
      </LabelWrapper>
    </MainWrapper>
  );
};

export default CustomTextBox;
